<template>
  <div class="region-stats-editor">
    <h4>Region Statistics Editor (Placeholder)</h4>
    <p>This is a placeholder for editing regional statistics settings.</p>

    <div class="form-group">
      <label for="regionName">Region Name</label>
      <input v-model="regionName" type="text" id="regionName" class="form-control" />
    </div>

    <button class="btn btn-primary" @click="emitDefinition">Apply</button>
  </div>
</template>

<script>
export default {
  name: 'RegionStatsEditor',
  props: {
    definition: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      regionName: this.definition.regionName || ''
    }
  },
  methods: {
    emitDefinition() {
      this.$emit('update', { regionName: this.regionName })
    }
  }
}
</script>

<style scoped>
.region-stats-editor {
  max-width: 400px;
  margin: auto;
}
</style>
